/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Error_SaveInputs */



/**
* | output |
* | --- |
* | "Couldn't save changes." |
*
* @param {User_Error_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_error_save = /** @type {((inputs?: User_Error_SaveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Error_SaveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'enregistrer les modifications.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron guardar los cambios.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível salvar as alterações.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile salvare le modifiche.")
	return /** @type {LocalizedString} */ ("Couldn't save changes.")
});